module.exports = __webpack_public_path__ + "img/icon_sword_loop.c929e0dd.gif";